/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import { makeStyles } from '@material-ui/core/styles'

import FlashContext from '../../components/contexts/FlashContext'
import Loading from '../../components/loading/Loading'
import api from '../../service/axios/api'
import { formatCurrency } from '../../service/utils'


const DRE_ROW_ORDER = [
  'Receitas Operacionais',
  'Outras Receitas Operacionais',
  'Receita Bruta',
  'Impostos',
  'Deduções Sobre Vendas',
  'Receita Líquida',
  'Custo das Vendas',
  'Resultado Operacional Bruto',
  'Despesas Administrativas',
  'Despesas com Estrutura',
  'Despesas com Pessoal',
  'Despesas Comerciais',
  'Resultado Operacional Líquido',
  'Receitas Financeiras',
  'Despesas Financeiras',
  'Receitas Não Operacionais',
  'Despesas Não Operacionais',
  'Resultado Líquido',
  'Participações e Dividendos',
  'Resultado Líquido do Exercício',
]

const SUBTOTAIS = [
  'Receita Bruta',
  'Receita Líquida',
  'Resultado Operacional Bruto',
  'Resultado Operacional Líquido',
  'Resultado Líquido',
  'Resultado Líquido do Exercício',
]

const MESES = [
  { value: 1,  label: 'Jan' },
  { value: 2,  label: 'Fev' },
  { value: 3,  label: 'Mar' },
  { value: 4,  label: 'Abr' },
  { value: 5,  label: 'Mai' },
  { value: 6,  label: 'Jun' },
  { value: 7,  label: 'Jul' },
  { value: 8,  label: 'Ago' },
  { value: 9,  label: 'Set' },
  { value: 10, label: 'Out' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dez' },
]


const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },

  filtersRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
  },
  formControl: { minWidth: 140 },

  tableContainer: {
    overflowX: 'auto',
    borderRadius: 8,
  },

  // Cabeçalho da tabela
  tableHead: {
    backgroundColor: '#1a5276',
    '& th': {
      color: '#fff',
      fontWeight: 700,
      fontSize: '0.78rem',
      whiteSpace: 'nowrap',
      padding: '8px 12px',
      borderRight: '1px solid rgba(255,255,255,0.1)',
    },
    '& th:last-child': {
      borderRight: 'none',
      backgroundColor: '#154360',
    },
  },

  // Linha branca (centro de custo)
  rowBranca: {
    backgroundColor: '#fff',
    '& td': {
      fontSize: '0.8rem',
      padding: '6px 12px',
      borderBottom: '1px solid #f0f0f0',
      borderRight: '1px solid #f5f5f5',
      whiteSpace: 'nowrap',
    },
    '&:hover': { backgroundColor: '#f9f9f9' },
  },

  // Linha cinza (subtotal)
  rowCinza: {
    backgroundColor: '#d5d8dc',
    '& td': {
      fontSize: '0.82rem',
      fontWeight: 700,
      padding: '7px 12px',
      borderBottom: '1px solid #bfc9ca',
      borderRight: '1px solid #c0c0c0',
      whiteSpace: 'nowrap',
      color: '#1a252f',
    },
  },

  // Coluna de rótulo (primeira coluna)
  labelCell: {
    position: 'sticky',
    left: 0,
    zIndex: 1,
    minWidth: 220,
    maxWidth: 220,
  },
  labelCellBranca: {
    backgroundColor: '#fff',
  },
  labelCellCinza: {
    backgroundColor: '#d5d8dc',
  },

  // Coluna Total (última)
  totalCell: {
    backgroundColor: '#eaf2ff',
    fontWeight: 700,
    borderLeft: '2px solid #1a5276 !important',
  },
  totalHeaderCell: {
  backgroundColor: '#154360 !important',
  borderLeft: '2px solid rgba(255,255,255,0.4) !important',
  },
  totalCellCinza: {
    backgroundColor: '#c8d6e5',
  },

  // Valores positivos / negativos
  positivo: { color: '#1e8449' },
  negativo: { color: '#c0392b' },

  // Linha de título da tabela (header verde azulado)
  dreHeader: {
    backgroundColor: '#1a5276',
    '& td': {
      color: '#fff',
      fontWeight: 700,
      fontSize: '0.85rem',
      padding: '10px 12px',
      letterSpacing: '0.05em',
    },
  },

  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(8),
    color: '#aaa',
    fontSize: '0.9rem',
  },
}))


const fmt = (value) => {
  if (value === undefined || value === null) return 'R$ 0,00'
  return formatCurrency(parseFloat(value) || 0)
}

const isSubtotal = (linha) => SUBTOTAIS.includes(linha)

export default function DRE() {
  const classes = useStyles()
  const { notifyError } = useContext(FlashContext)

  const currentYear = new Date().getFullYear()

  const yearOptions = Array.from({ length: 5 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  const statusOptions = [
    { value: 'ambos',  label: 'Ambos' },
    { value: 'Pago',   label: 'Realizado' },
    { value: 'Pendente', label: 'Previsto' },
  ]

const [loading, setLoading] = useState(false)
const [year, setYear]       = useState(currentYear.toString())
const [status, setStatus]   = useState('ambos')
const [meses, setMeses]     = useState({})
const [total, setTotal]     = useState({})
const [mesesPrevisto, setMesesPrevisto]   = useState({})
const [mesesRealizado, setMesesRealizado] = useState({})
const [totalPrevisto, setTotalPrevisto]   = useState({})
const [totalRealizado, setTotalRealizado] = useState({})
const [ordem, setOrdem]     = useState([])


const searchData = async () => {
  setLoading(true)
  try {
    const response = await api.dre.getAll({ year, status })
   // const { meses: mesesData, total: totalData } = response.data

    if (status === 'ambos') {
      setMesesPrevisto(response.data.mesesPrevisto || {})
      setMesesRealizado(response.data.mesesRealizado || {})
      setTotalPrevisto(response.data.totalPrevisto || {})
      setTotalRealizado(response.data.totalRealizado || {})
    } else {
      setMeses(response.data.meses || {})
      setTotal(response.data.total || {})
    }
    setOrdem(response.data.ordem || []) 
  } catch (error) {
    notifyError(error.message)
  } finally {
    setLoading(false)
  }
}

  useEffect(() => {
    searchData()
  }, [year, status])


  const linhasOrdenadas = ordem
  const colSpanTotal = status === 'ambos' ? MESES.length * 2 + 3 : MESES.length + 2

  // ── Valor de uma célula ──
  const getValor = (mesIdx, linha) => {
    const mes = meses[mesIdx]
    if (!mes) return null
    return mes[linha]
  }

  return (
    <>
      <Loading open={loading} msg="Carregando DRE..." />

      <Grid container className={classes.root}>

        {/* Título */}
        <Grid item xs={12} style={{ marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>DRE — Demonstrativo do Resultado do Exercício</h3>
        </Grid>

        {/* Filtros */}
        <Grid item xs={12} className={classes.filtersRow}>
          <FormControl variant="outlined" size="small" className={classes.formControl}>
            <InputLabel>Ano</InputLabel>
            <Select
              value={year}
              onChange={(e) => setYear(e.target.value)}
              label="Ano"
            >
              {yearOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small" className={classes.formControl}>
            <InputLabel>Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Status"
            >
              {statusOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Tabela */}
        <Grid item xs={12}>
          <TableContainer component={Paper} elevation={2} className={classes.tableContainer}>
            <Table size="small">

            {/* Cabeçalho */}
            <TableHead className={classes.tableHead}>
            {status === 'ambos' ? (
              <>
                <TableRow>
                  <TableCell className={classes.labelCell} rowSpan={2} />
                  {MESES.map((m) => (
                    <TableCell key={m.value} align="center" colSpan={2}>{m.label}</TableCell>
                  ))}
                  <TableCell align="center" colSpan={2} className={classes.totalCell}>Total</TableCell>
                </TableRow>
                <TableRow>
                  {MESES.map((m) => (
                    <React.Fragment key={m.value}>
                      <TableCell align="right">Previsto</TableCell>
                      <TableCell align="right">Realizado</TableCell>
                    </React.Fragment>
                  ))}
                  <TableCell align="right" className={classes.totalHeaderCell}>Previsto</TableCell>
                  <TableCell align="right" className={classes.totalHeaderCell}>Realizado</TableCell>
                </TableRow>
              </>
            ) : (
              <TableRow>

                <TableCell className={classes.labelCell} /> 
                
                {MESES.map((m) => (
                <TableCell key={m.value} align="right">{m.label}</TableCell>
                ))}
                <TableCell align="right" className={classes.totalCell}>Total</TableCell>
            </TableRow>
              )}
              </TableHead>
              <TableBody>

                {/* Linha de título */}
                <TableRow className={classes.dreHeader}>
                  <TableCell colSpan={colSpanTotal}>
                    DEMONSTRATIVO DO RESULTADO DO EXERCÍCIO
                  </TableCell>
                </TableRow>

                {linhasOrdenadas.length === 0 && !loading ? (
                  <TableRow>
                    <TableCell colSpan={colSpanTotal} className={classes.emptyState}>
                      Nenhum dado encontrado para o período selecionado.
                    </TableCell>
                  </TableRow>
                ) : (

                  linhasOrdenadas.filter((linha) => linha && linha.trim() !== '').map((linha) => {
                    const subtotal = isSubtotal(linha)
                    const rowClass = subtotal ? classes.rowCinza : classes.rowBranca
                    const labelClass = subtotal ? classes.labelCellCinza : classes.labelCellBranca
                    const totalClass = subtotal ? classes.totalCellCinza : ''

                    return (
                      <TableRow key={linha} className={rowClass}>
                        {/* Nome da linha */}
                      
                          <TableCell
                            className={`${classes.labelCell} ${labelClass}`}
                            style={{
                              whiteSpace: 'normal',
                              wordBreak: 'break-word',
                              maxWidth: 200
                            }}
                          >
                            {linha}
                          </TableCell>
                        

                        {/* Valores mensais */}
                        {status === 'ambos' ? (
                          <>
                            {MESES.map((m) => {
                              const valorPrevisto = mesesPrevisto[m.value]?.[linha]
                              const valorRealizado = mesesRealizado[m.value]?.[linha]
                              return (
                                <React.Fragment key={m.value}>
                                  <TableCell
                                    align="right"
                                    className={valorPrevisto < 0 ? classes.negativo : ''}
                                  >
                                    {fmt(valorPrevisto)}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={valorRealizado < 0 ? classes.negativo : ''}
                                  >
                                    {fmt(valorRealizado)}
                                  </TableCell>
                                </React.Fragment>
                              )
                            })}

                            <TableCell
                              align="right"
                              className={`${classes.totalCell} ${totalClass} ${
                                (totalPrevisto[linha] || 0) < 0 ? classes.negativo : ''
                              }`}
                            >
                              {fmt(totalPrevisto[linha])}
                            </TableCell>
                            <TableCell
                              align="right"
                              className={`${classes.totalCell} ${totalClass} ${
                                (totalRealizado[linha] || 0) < 0 ? classes.negativo : ''
                              }`}
                            >
                              {fmt(totalRealizado[linha])}
                            </TableCell>
                          </>
                        ) : (
                          <>
                            {MESES.map((m) => {
                              const valor = getValor(m.value, linha)
                              const isNeg = valor < 0
                              return (
                                <TableCell
                                  key={m.value}
                                  align="right"
                                  className={isNeg ? classes.negativo : ''}
                                >
                                  {fmt(valor)}
                                </TableCell>
                              )
                            })}

                            <TableCell
                              align="right"
                              className={`${classes.totalCell} ${totalClass} ${
                                (total[linha] || 0) < 0 ? classes.negativo : ''
                              }`}
                            >
                              {fmt(total[linha])}
                            </TableCell>
                          </>
                          )}
                      </TableRow>
                    )
                  })
                )}

              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

      </Grid>
    </>
  )
}